import styled from '@emotion/styled';

export const MutedText = styled.span`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.gray};
`;
